/*!
 * Copyright (c) 2017-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import React, { useEffect } from 'react';
import { toRelativeUrl } from '@okta/okta-auth-js';
import { Outlet, useNavigate } from 'react-router-dom';
import Loading from '../components/Loading';
import { isAuthEnabled } from '../utils/config';
import { useUnifiedAuth } from './AuthContext';
const authEnabled = isAuthEnabled();

export const RequiredAuth: React.FC = authEnabled
  ? () => {
      const { unifiedAuthState } = useUnifiedAuth();
      const navigate = useNavigate();

      useEffect(() => {
        if (!unifiedAuthState) {
          return;
        }

        if (!unifiedAuthState?.isAuthenticated) {
          let originalUri = toRelativeUrl(window.location.href, window.location.origin);

          navigate(originalUri === '/' ? '/login' : `/login?uri=${encodeURIComponent(originalUri)}`);
        }
      }, [unifiedAuthState]);

      if (!unifiedAuthState || !unifiedAuthState?.isAuthenticated) {
        return (
          <div className="fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center bg-white z-50">
            <Loading />
          </div>
        );
      }

      return <Outlet />;
    }
  : () => {
      return <Outlet />;
    };
